import qoalaStorage from '~/core/Storage';

export default {
  updatePolicyList(state, value) {
    state.policyList = value;
  },
  updateClaimList(state, value) {
    state.claimList = value;
  },
  updateDocumentsType(state, value) {
    qoalaStorage.setItem('documentsType', JSON.stringify(value));
    state.documentsType = value;
  },
  updateOTAList(state, value) {
    qoalaStorage.setItem('OTAList', JSON.stringify(value));
    state.OTAList = qoalaStorage.getItem('OTAList');
  }
};
